fV = require '../../../a2i/js/lib/formValidations'
React = require 'react'
slow = require '../lib/slow'
SummaryQuestionsComponent = require '../components/SummaryQuestions'
{ createObservationQuestionResponses } = require '../actions/observations'
{ Component, PropTypes } = React
{ doFlash } = require '../actions/flash'
{ reduxForm } = require 'redux-form'

class SummaryQuestionsContainer extends Component
	@propTypes:
		createObservationQuestionResponses: PropTypes.func.isRequired
		toggleAnswerSummaryQuestions: PropTypes.func.isRequired

	onSubmit: (values) =>
		{ doFlash, observationId, toggleAnswerSummaryQuestions } = @props
		slow()
		.then =>
			@props.createObservationQuestionResponses(values)
			toggleAnswerSummaryQuestions()

	render: =>
		React.createElement(SummaryQuestionsComponent, React.__spread({}, \
			@props, { \
			"onSubmit": ( @onSubmit )
		}))

mapStateToProps = (state) -> {}

mapDispatchToProps = {
	createObservationQuestionResponses
	doFlash
}

module.exports = reduxForm({
	form: 'SummaryQuestions'
	fields: ['fakeField']
	validate: fV.createValidator {}
}, mapStateToProps, mapDispatchToProps)(SummaryQuestionsContainer)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/SummaryQuestions.cjsx